// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".benefit[data-v-641d816c]{margin-bottom:1.5rem;width:100%}@media screen and (min-width:767px){.benefit[data-v-641d816c]{width:50%}.benefit[data-v-641d816c]:nth-child(odd){padding-right:1rem}.benefit[data-v-641d816c]:nth-child(2n){padding-left:1rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
